var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showEnvToggler)?_c('v-btn',{staticClass:"env-toggler",class:{ '--active' : _vm.isDevMode },attrs:{"depressed":"","small":""},on:{"click":_vm.toggleMode}},[_vm._v(" ENV = "+_vm._s(_vm.envMode)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }